import { Component } from '@angular/core';
import {NavBarComponent} from "../nav-bar/nav-bar.component";
import {HeroEspecialidadesComponent} from "./hero-especialidades/hero-especialidades.component";
import {EspecialidadesListComponent} from "./especialidades-list/especialidades-list.component";
import {FooterComponent} from "../../footer/footer.component";
import {FloatButtonComponent} from "../../float-button/float-button.component";
import {FooterPersonaComponent} from "../footer-persona/footer-persona.component";
import {TopBarComponent} from "../../top-bar/top-bar.component";

//Aunque contiene la data de demo.servicios_procedimientos el componente lleva por nombre especialidades
//debido a que a ojos de la lógica de negocio se le llama asi a los servicios_procedimientos

@Component({
  selector: 'app-especialidades-person',
  standalone: true,
  imports: [
    NavBarComponent,
    HeroEspecialidadesComponent,
    EspecialidadesListComponent,
    FooterComponent,
    FloatButtonComponent,
    FooterPersonaComponent,
    TopBarComponent
  ],
  templateUrl: './especialidades-person.component.html',
  styleUrl: './especialidades-person.component.css'
})
export class EspecialidadesPersonComponent {

}
